/* ==========================================================================
   FlatWine — collection.js
   Filtros de la colección. Los <details> funcionan sin JS; esto sólo
   añade auto-envío al cambiar y cierre al hacer clic fuera.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var form = document.querySelector('[data-filters-form]');
    if (!form) return;

    // Con JS, cambiar un filtro aplica de inmediato.
    form.addEventListener('change', function (event) {
      if (event.target.matches('input, select')) form.submit();
    });

    // Un solo panel abierto a la vez.
    //
    // Se cierra en el 'click' del summary, no en el 'toggle' del details:
    // 'toggle' se dispara de forma asíncrona, así que con dos aperturas
    // seguidas los handlers se pisan y termina abierto el panel
    // equivocado. 'click' es síncrono y corre antes de que el navegador
    // abra el details, así que el resultado es siempre el que el usuario
    // pidió.
    var panels = form.querySelectorAll('details.filter');

    form.addEventListener('click', function (event) {
      var summary = event.target.closest('details.filter > summary');
      if (!summary) return;

      var current = summary.parentElement;
      panels.forEach(function (other) {
        if (other !== current) other.open = false;
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('details.filter')) return;
      panels.forEach(function (panel) { panel.open = false; });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      panels.forEach(function (panel) { panel.open = false; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
